<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H36C36.4142 7.25 36.75 7.58579 36.75 8V32C36.75 32.4142 36.4142 32.75 36 32.75H4C3.58579 32.75 3.25 32.4142 3.25 32V8ZM4.75 8.75V25.3513L16.1262 15.4346C16.4288 15.1709 16.8853 15.1921 17.1622 15.4828L32.1786 31.25H34.25L24.273 20.7741L25.3592 19.7397L35.25 30.125V8.75H4.75ZM30.1071 31.25L16.5709 17.0369L4.75 27.3412V31.25H30.1071Z"
      class="fill-current"
    />
    <path d="M4 32V27L16.619 16L31.8571 32H4Z" class="fill-current" />
  </svg>
</template>
